import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-sales-cta',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './sales-cta.html',
  styleUrls: ['./sales-cta.css'],
})
export class SalesCtaComponent {}
